import fortify from '../../../img/fortify.png';
import './Projectleftimage.css';

const ProjectImage = () => {
  return (
    <img 
      src={fortify} 
      alt="Fortify chat application" 
      className="photossss reveal fade-left" 
    />
  );
};

export default ProjectImage;
